import { t } from 'i18next';

import { ErrorResponseErrorItemCodeFolder } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeFolder, string> => ({
  'folder:name_exists': t?.('folder.nameExists', { ns: 'apiErrorCodes' }),
  'folder:not_found': t?.('folder.notFound', { ns: 'apiErrorCodes' }),
  'folder:user_unauthorized': t?.('folder.userUnauthorized', { ns: 'apiErrorCodes' }),
  'folder:root_folder_not_found': t?.('folder.rootFolderNotFound', { ns: 'apiErrorCodes' }),
  'folder:integration_sync_folder_cannot_be_renamed': t?.(
    'folder.integrationSyncFolderCannotBeRenamed',
    { ns: 'apiErrorCodes' },
  ),
  'folder:integration_sync_folder_cannot_be_moved': t?.(
    'folder.integrationSyncFolderCannotBeMoved',
    { ns: 'apiErrorCodes' },
  ),
  'folder:integration_sync_folder_content_cannot_be_moved': t?.(
    'folder.integrationSyncFolderContentCannotBeMoved',
    { ns: 'apiErrorCodes' },
  ),
  'folder:content_cannot_be_dropped_into_integration_sync_folder': t?.(
    'folder.contentCannotBeDroppedIntoIntegrationSyncFolder',
    { ns: 'apiErrorCodes' },
  ),
  'folder:not_found_in_project': t?.('folder.notFoundInProject', { ns: 'apiErrorCodes' }),
});
